<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- วัน -->
              <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                label="วัน"
                class="ma-2"
              ></v-select>
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon
                color="#871B12"
                size="30"
                @click="getData()"
                >mdi-calendar-search</v-icon
              >
              <v-icon
                color="#871B12"
                size="30"
                @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <v-row >
          <v-col cols="6">
            <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="blue-grey"
              class="ma-2 white--text"
              @click="(loader = 'loading3'), exportEmpInfo()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="searchAll2"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.DateCheckIN`]="{ item }">
                    {{item.checkInDay}}/{{item.checkInMonth}}/{{item.checkInYear}}
                  </template>
                  <template v-slot:[`item.DeleteCheckout`]="{ item }">
                    <v-btn
                     v-if="item.checkInEndStamp"
                      color="orange"
                      @click.stop="updateCheckOUT(item)"
                    > ลบข้อมูลออกงาน
                      <v-icon> mdi-close-circle </v-icon>
                    </v-btn>
                    <v-btn
                     v-if="item.checkInEndStamp"
                      color="red"
                      @click.stop="updateCheckAll(item)"
                    > ลบข้อมูลทั้งหมด
                      <v-icon> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="success"
                      fab
                      small
                      @click.stop="(dialog = true), getByEmp(item)"
                    >
                      <v-icon dark> mdi-map-marker </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
              <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>รายละเอียด</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-col cols="12">
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header disable-icon-rotate>
                      <template v-slot:actions>
                        <v-icon color="#871B12">
                          mdi-account-circle-outline
                        </v-icon>
                      </template>
                      {{ dataByEmp.empFull_NameTH }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="4">
                              <v-card elevation="2">
                                <center>
                                  <v-avatar
                                    class="profile"
                                    style="margin-top: 10px"
                                    color="grey"
                                    size="164"
                                    rounded
                                  >
                                    <v-img :src="dataByEmp.empImageUrl"></v-img>
                                  </v-avatar>
                                </center>
                                <v-col>
                                  <v-card-text
                                    ><v-icon color="#871B12">mdi-account</v-icon
                                    ><strong>ชื่อ-นามสกุล: </strong
                                    >{{ dataByEmp.empFull_NameTH }}
                                  </v-card-text>
                                  <v-card-text>
                                    <v-icon color="#871B12">mdi-account</v-icon>
                                    <strong>หน่วยงาน: </strong
                                    >{{ dataByEmp.masDepartmentName }}
                                  </v-card-text>
                                  <v-card-text>
                                    <v-icon color="#871B12">mdi-account</v-icon>
                                    <strong>สาขา : </strong
                                    >{{ dataByEmp.masBranchName }}
                                  </v-card-text>
                                  <v-card-text
                                    ><v-icon color="#871B12">mdi-account-box</v-icon
                                    ><strong>รหัสพนักงาน : </strong
                                    >{{ dataByEmp.empCode }}</v-card-text
                                  >
                                  <v-card-text
                                    ><v-icon color="#871B12"> mdi-cellphone-basic </v-icon
                                    ><strong>เบอร์โทรศัพท์ : </strong
                                    >{{ dataByEmp.empTel }}</v-card-text
                                  >
                                  <v-card-text
                                    ><v-icon color="#871B12"> mdi-email </v-icon
                                    ><strong>อีเมล์ : </strong>{{ dataByEmp.empEmail }}
                                  </v-card-text>
                                </v-col>
                              </v-card>
                            </v-col>
                            <v-col cols="4">
                              <v-card elevation="2">
                                <v-simple-table  fixed-header height="530px">
                                  <template v-slot:default>
                                    <thead>
                                      <tr >
                                        <th class="text-center" style="background-color: #1B437C;">วัน/เดือน/ปี</th>
                                        <th class="text-center" style="background-color: #1B437C;">เวลาเข้างาน</th>
                                        <th class="text-center" style="background-color: #1B437C;">เวลาเลิกงาน</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(
                                          items1, index1
                                        ) in dataByEmp.shifttem"
                                        :key="index1"
                                      >
                                        <td>
                                          {{ items1.shiftDay }}/{{
                                            items1.shiftMonth
                                          }}/{{ items1.shiftYear }}
                                        </td>
                                        <td>
                                          <v-chip
                                            class="ma-2"
                                            :color="items1.colorin"
                                            text-color="white"
                                            @click="openWindows(items1)"
                                          >
                                            {{ items1.checkInStartStamp }}
                                          </v-chip>
                                        </td>
                                        <td>
                                          <v-chip
                                            class="ma-2"
                                            :color="items1.colorout"
                                            text-color="white"
                                            @click="openWindows2(items1)"
                                          >
                                            {{ items1.checkInEndStamp }}
                                          </v-chip>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-card>
                            </v-col>

                             <v-col cols="4">
                                <v-card elevation="2">
                                  <v-simple-table fixed-header height="530px">
                                    <template v-slot:default>
                                      <thead>
                                        <tr>
                                          <th
                                            class="text-center"
                                            style="background-color: #1b437c"
                                          >
                                            วัน/เดือน/ปี
                                          </th>
                                          <th
                                            class="text-center"
                                            style="background-color: #1b437c"
                                          >
                                            เวลา
                                          </th>
                                          <th
                                            class="text-center"
                                            style="background-color: #1b437c"
                                          >
                                            สี
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          v-for="(items2, index2) in dataByEmp.shifttem"
                                          :key="index2"
                                        >
                                          <td class="text-center">
                                            {{ items2.shiftDay }}/{{
                                              items2.shiftMonth
                                            }}/{{ items2.shiftYear }}
                                          </td>
                                          <td v-if="items2.time_as" class="text-center">
                                            {{ items2.time_as }}
                                          </td>
                                          <td v-if="!items2.time_as" class="text-center">
                                            <v-chip class="ma-2"> ไม่พบข้อมูล </v-chip>
                                          </td>
                                          <td class="text-center">
                                            <v-chip
                                              v-if="items2.color === 'สีเขียว'"
                                              class="ma-2"
                                              color="green"
                                              text-color="white"
                                            >
                                              {{ items2.color }}
                                            </v-chip>
                                            <v-chip
                                              v-if="items2.color === 'สีเหลือง'"
                                              class="ma-2"
                                              color="yellow"
                                              text-color="black"
                                            >
                                              {{ items2.color }}
                                            </v-chip>
                                            <v-chip
                                              v-if="items2.color === 'สีแดง'"
                                              class="ma-2"
                                              color="red"
                                              text-color="black"
                                            >
                                              {{ items2.color }}
                                            </v-chip>
                                            <v-chip
                                              v-if="items2.color === 'สีส้ม'"
                                              class="ma-2"
                                              color="orange"
                                              text-color="black"
                                            >
                                              {{ items2.color }}
                                            </v-chip>
                                            <v-chip class="ma-2" v-if="!items2.color">
                                              ไม่พบข้อมูล
                                            </v-chip>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </v-card>
                              </v-col>
                        <v-col cols="12">
                          <v-col>
                            <!-- {{dataByEmp.shifttem}}
                        <label v-for="items2 in dataByEmp.shifttem" :key="items2" >
                            {{items2.position}}
                            </label> -->
                            <!-- {{dataByEmp.shifttem}} -->
                            <GmapMap
                              :center="center"
                              map-type-id="terrain"
                              ref="mapRef"
                              :zoom="zoom"
                              style="width: 100%; height: 600px"
                              :options="{ disableDefaultUI: true }"
                            >
                              <GmapMarker :position="center" />
                              <GmapMarker
                                v-for="(
                                  m, indexMap1
                                ) in dataByEmp.shifttemMapCheckIn"
                                :key="indexMap1"
                                :position="m.positionIn"
                                :clickable="true"
                                :icon="m.iconIn"
                                @click="openWindows(m)"
                              />
                              <GmapMarker
                                v-for="(
                                  m2, indexMap2
                                ) in dataByEmp.shifttemMapCheckout"
                                :key="indexMap2 + 'M2'"
                                :position="m2.positionOut"
                                :clickable="true"
                                :icon="m2.iconOut"
                                @click="openWindows2(m2)"
                              />
                            </GmapMap>
                          </v-col>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-card>
          </v-dialog>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment'
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { gmapApi } from 'vue2-google-maps'
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    gmapApi
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/ch_checkin/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'จัดการประวัติเข้าออกงานสาขา',
          disabled: false,
          href: '/CheckINOUT/ManageCheckINOUTBranch'
        }
      ],
      // End Menu Config
      dialog: false,
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'PL_', // Generate Code
      valid_add: true,
      valid_update: true,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      year: '',
      month: '',
      day: '',
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      search: {
        vaccineId: '',
        vaccineName: '',
        vaccineCategory: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formAdd: {
        vaccineId: '',
        vaccineName: '',
        vaccineCategory: ''
      },
      formUpdate: {
        vaccineId: '',
        vaccineName: '',
        vaccineCategory: ''
      },
      formUpdateItem: {
        vaccineId: '',
        vaccineName: '',
        vaccineCategory: ''
      },
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 30 || 'Name must be less than 30 characters'
      ],
      numberRule: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 999) ||
          'Number has to be between 0 and 999'
      ],
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'วัน/เดือน/ปี', value: 'DateCheckIN' },
        { text: 'กะ', value: 'masShiftTypeName' },
        { text: 'เข้างาน', value: 'checkInStartStamp' },
        { text: 'ออกงาน', value: 'checkInEndStamp' },
        { text: 'ลบข้อมูล', value: 'DeleteCheckout', sortable: false, align: 'center' },
        { text: 'ดูข้อมูล', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      export_data: [],
      dataByEmp: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'vaccineId', value: 'vaccineId' },
        { text: 'vaccineId', value: 'vaccineId' },
        { text: 'vaccineName', value: 'vaccineName' },
        { text: 'vaccineCategory', value: 'vaccineCategory' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      center: {},
      // End Config Import
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      loading3: false
    }
  },
  async mounted () {
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()

    await this.getGetToken()
    await this.geolocate()
    this.dataReady = false
    // Get Data
    await this.getData()
  },
  methods: {
    geolocate () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.dataReady = true
          console.log('center : ', center)
          this.center = center
        },
        (error) => {
          console.log('error map :', error.message)
          alert('กรุณาเปิด location ของท่าน')
        }
      )
    },
    async getData () {
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get?checkInDay=" +
            this.day +
            '&checkInMonth=' +
            this.getMonthThToINT(this.month) +
            '&checkInYear=' +
            this.year + '&masBranchName=' + this.$session.getAll().data.masBranchName, {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    exportEmpInfo () {
      var tem = []
      // var wb = XLSX.utils.book_new() // make Workbook of Excel
      this.dataItem.forEach((element) => {
        console.log(element)
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'วันเดือนปี': element.checkInDay + '/' + element.checkInMonth + '/' + element.checkInYear,
          'รหัสกะ': element.masShiftTypeCode,
          'กะเข้างาน': element.masShiftTypeStartTime,
          'กะเวลาออกงาน': element.masShiftTypeEndTime,
          'สถานที่ทำงาน': element.location,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'สถานะสาย': element.lateStatus,
          'สาย(นาที)': element.lateTime,
          'ระดับสีประเมินความเสี่ยง': element.color
        }
        tem.push(s)
      })
      var info = XLSX.utils.json_to_sheet(tem)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'checkin_out.xls') // name of the file is 'book.xlsx'
    },
    async getByEmp (dt) {
      // let date = new Date()
      this.month = this.getMonthTh()
      this.year = moment().format('YYYY')
      dt.empImageUrl = this.DNS_IP + '/' + dt.empImageUrl
      this.dataReady = false
      this.dataByEmp = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?empCode=' +
            dt.empCode +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          this.dataReady = true
          dt.shifttem = response.data
          dt.shifttemMapCheckIn = response.data
          dt.shifttemMapCheckout = response.data
          this.mapGetDataCheckIn(dt.shifttemMapCheckIn)
          this.mapGetDataCheckOut(dt.shifttemMapCheckout)
          dt.shifttem.forEach((shifttem) => {
            if (shifttem.checkInStartStamp) {
              var date =
                shifttem.checkInYear +
                '-' +
                shifttem.checkInMonth +
                '-' +
                shifttem.checkInDay
              var startStamp = new Date(
                date + ' ' + shifttem.checkInStartStamp
              )
              var masShiftTypeStartTime = new Date(
                date + ' ' + shifttem.masShiftTypeStartTime
              )
              if (startStamp > masShiftTypeStartTime) {
                shifttem.colorin = 'red'
              } else {
                shifttem.colorin = 'green'
              }

              if (shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = shifttem.checkInEndStamp
                shifttem.colorout = 'green'
              } else {
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.colorout = '-'
              }
            } else {
              shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
              shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
              shifttem.colorin = '-'
              shifttem.colorout = '-'
            }
          })
          dt.shifttem = dt.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
          this.dataByEmp = dt
          console.log('dt : ', this.dataByEmp)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    mapGetDataCheckIn (dt) {
      dt.forEach((shifttem) => {
        // var position = {
        //   lat: null,
        //   lng: null
        // }
        if (shifttem.checkInStartLat && shifttem.checkInStartLong) {
          var position = {
            lat: parseFloat(shifttem.checkInStartLat),
            lng: parseFloat(shifttem.checkInStartLong)
          }

          shifttem.iconIn =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fin.png?alt=media'
          shifttem.positionIn = position
          this.center = position
        }
      })
    },
    mapGetDataCheckOut (dt) {
      dt.forEach((shifttem) => {
        // var position = {
        //   lat: null,
        //   lng: null
        // }
        if (shifttem.checkInEndLat && shifttem.checkInEndLong) {
          var position = {
            lat: parseFloat(shifttem.checkInEndLat),
            lng: parseFloat(shifttem.checkInEndLong)
          }

          shifttem.iconOut =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fout.png?alt=media'
          shifttem.positionOut = position
          this.center = position
        }
      })
    },
    openWindows (m) {
      console.log('m', m)
      this.zoom = 19
      this.center = m.positionIn
      this.window_open = true
      this.infowindow_position = m.positionIn

      this.infowindow_detail = 'วันที่ ' + m.checkInDay + '/' + m.checkInMonth + '/' + m.checkInYear + '\nเข้างานเมื่อ ' + m.checkInStartStamp
      // this.panToMarker(this.center)
    },
    openWindows2 (m) {
      console.log('m2', m)
      this.zoom = 19
      this.center = m.positionOut
      this.infowindow_position = m.positionOut
      this.window_open = true
      this.infowindow_detail = 'วันที่ ' + m.checkInDay + '/' + m.checkInMonth + '/' + m.checkInYear + '\nออกงานเมื่อ ' + m.checkInEndStamp
      // this.panToMarker(this.center)
    },
    updateCheckOUT (item) {
      console.log('update checkin', item)
      let ds = {
        LAST_USER: this.$session.getAll().data.userName
      }
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "deleteCheckOUT/" + item.checkInId,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    updateCheckAll (item) {
      let ds = {
        LAST_USER: this.$session.getAll().data.userName
      }
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "delete/" + item.checkInId,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async clear () {
      this.month = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      await this.getData()
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/CheckINOUT/ManageCheckINOUTBranch.vue